import { render, staticRenderFns } from "./mgcGameListModal.vue?vue&type=template&id=0e3fb2e4&scoped=true"
import script from "./mgcGameListModal.vue?vue&type=script&lang=js"
export * from "./mgcGameListModal.vue?vue&type=script&lang=js"
import style0 from "./mgcGameListModal.vue?vue&type=style&index=0&id=0e3fb2e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3fb2e4",
  null
  
)

export default component.exports